import { Map, List, fromJS } from 'immutable'

export function formData(state = Map(), action) {
  let formState

  switch (action.type) {
    case 'FORM_ON_CHANGE':
      formState = state.get(action.formId, Map())
      formState = formState.setIn(['values'].concat(action.name.split('.')), action.value)
      formState = formState.setIn(['changed'].concat(action.name.split('.')), action.value)
      return state.set(action.formId, formState)

    case 'FORM_ON_BATCH_CHANGE':
      formState = state.get(action.formId, Map())

      if (List.isList(action.values)) action.values = action.values.toJS()

      if (!Array.isArray(action.values)) {
        console.log('Form batch update values must be an array', action.values)
        return state
      }

      for (let batchData of action.values) {
        formState = formState.setIn(['values'].concat(batchData.name.split('.')), batchData.value)
        formState = formState.setIn(['changed'].concat(batchData.name.split('.')), batchData.value)
      }
      return state.set(action.formId, formState)

    case 'FORM_SUBMIT_LOADING':
      return state.setIn([action.formId, 'loading'], action.loading || false)

    case 'FORM_SUBMIT_SUCCESS':
      state = state.setIn([action.formId, 'loading'], false)
      return state.setIn([action.formId, 'changed'], Map())

    case 'FORM_SUBMIT_ERROR':
    case 'FORM_SUBMIT_VALIDATION_ERROR':
      return state
        .setIn([action.formId, 'errors'], action.errors || Map())
        .setIn([action.formId, 'messages'], action.messages || List())
        .setIn([action.formId, 'loading'], false)

    case 'FORM_SET_MESSAGES':
      return state.setIn(
        [action.formId, 'messages'],
        List.isList(action.messages) ? action.messages : fromJS(action.messages || [])
      )

    case 'FORM_INIT':
      let values = Map.isMap(action.values) ? action.values : fromJS(action.values)
      state = state.setIn([action.formId, 'originalValues'], values)
      state = state.setIn([action.formId, 'values'], values)
      return state

    case 'FORM_SET_META':
      let meta = Map.isMap(action.meta) ? action.meta : fromJS(action.meta)
      return state.setIn([action.formId, 'meta'], meta)

    case 'FORM_RESET':
      return state.removeIn([action.formId])

    case 'FORM_LOAD_REFERENCE_DATA_LOADING':
      return state.setIn(['_referenceLoading', action.id], action.loading)

    case 'FORM_LOAD_REFERENCE_DATA_SUCCESS':
      return state.setIn(['_referenceData', action.id], fromJS(action.items))

    case 'FORM_LOAD_REFERENCE_DATA_ERROR':
      return state.setIn(['_referenceError', action.id], action.message)

    case 'FORM_LOAD_REFERENCE_DATA_RESET':
      return state
        .removeIn(['_referenceError', action.id])
        .removeIn(['_referenceData', action.id])
        .removeIn(['_referenceLoading', action.id])

    case 'FORM_LOAD_LINKS_DATA_LOADING':
      return state.setIn(['_linksLoading'], action.loading)

    case 'FORM_LOAD_LINKS_DATA_SUCCESS':
      return state.setIn(['_linksData'], fromJS(action.data))

    case 'FORM_LOAD_LINKS_DATA_ERROR':
      return state.setIn(['_linksError'], action.message)

    case 'FORM_LOAD_LINKS_DATA_RESET':
      return state.removeIn(['_linksError']).removeIn(['_linksData']).removeIn(['_linksLoading'])

    default:
      return state
  }
}
